import { useState } from "react";
import { Box } from "@mui/material"
import HamburgerButtonDropdownMenu from "../HamburgerButtonDropdownMenu";

export default function HamburgerButton({...params}){

    let page = params.page
    let channelID = params.channelID
    let canEdit = params.canEdit
    let isAdmin = params.isAdmin
    let hamburgerButtonState = params.hamburgerButtonState
    let setHamburgerButtonState = params.setHamburgerButtonState

    const [menuAnchor, setMenuAnchor] = useState(null); //sets menu positioning

    const closeMenu = () => {
        setHamburgerButtonState('default')
        setMenuAnchor(null);
    };

    const handleButtonClick = (event) => {
        event.preventDefault()
        setHamburgerButtonState('active')
        setMenuAnchor(event.currentTarget);
    };

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (hamburgerButtonState !== 'active') setHamburgerButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        if (hamburgerButtonState !== 'active') setHamburgerButtonState('default')
    }

    let imagePaths = ["/icons/icons-shared/icon-hamburger-active.svg", "/icons/icons-shared/icon-hamburger-default.svg", "/icons/icons-shared/icon-hamburger-hover.svg"]

    let imagePath = ''
    if (hamburgerButtonState === 'active') imagePath = imagePaths[0]
    else if (hamburgerButtonState === 'default') imagePath = imagePaths[1]
    else if (hamburgerButtonState === 'hover') imagePath = imagePaths[2]

    return (
        <>
            <Box paddingRight={'50px'} paddingLeft={'82px'} paddingTop={'30px'} paddingBottom={'30px'} id={"HamburgerButtonContainer"}>
                <Box 
                    component="img" src={imagePath} zIndex={110} id={"HamburgerButton"}
                    width={'50px'} height={'35px'} 
                    padding={'5px'}

                    display={'flex'}
                    justifySelf={'flex-start'}
                    onClick={(event) => handleButtonClick(event)} 
                    onMouseOut={(event) => handleButtonMouseOut(event)} 
                    onMouseOver={(event) => handleButtonHover(event)}
                />
            </Box>
            <HamburgerButtonDropdownMenu
                page={page}
                channelID={channelID}
                canEdit={canEdit}
                isAdmin={isAdmin}
                menuAnchor={menuAnchor}
                closeMenu={closeMenu}
            />
        </>
    )
}
